{
  "title": "Søk",
  "programmesTitle": "Studier og kurs",
  "placeholder": "Søk",
  "sort": {
    "label": "Sorter etter",
    "relevance": "Relevans",
    "alphabetical": "Alfabetisk"
  },
  "showAll": "Vis alle ({{count}})",
  "tabs": {
    "all": "Alle treff",
    "programmes": "Studier og kurs",
    "articles": "Artikler",
    "employees": "Ansatte",
    "events": "Arrangementer"
  },
  "count": {
    "All": "Viser {{count}} treff",
    "Programmes": "Viser {{count}} studier og kurs",
    "Articles": "Viser {{count}} artikler",
    "Employees": "Viser {{count}} ansatte",
    "Events": "Viser {{count}} arrangementer"
  },
  "findExpert": {
    "title": "Ekspertkompetanse",
    "description": "Er du på jakt etter en som kan uttale seg om et gitt tema?",
    "linkText": "Finn en ekspert"
  },
  "pagination": {
    "nextPage": "Neste side",
    "previousPage": "Forrige side",
    "page": "Side {{page}}"
  },
  "filter": {
    "header": "Filtrer",
    "toggleButton": "Filter",
    "resetButton": "Nullstill filter",
    "applyButton": "Filtrer",
    "closeButton": "Lukk filter"
  },
  "article": {
    "noResults": "Det er dessverre ingen artikler som passer søkekriteriene du har oppgitt",
    "typeFilter_zero": "Artikkel",
    "typeFilter": "Artikkel ({{count}})",
    "type": "Artikkel",
    "types": {
      "BiBusinessReview": "BI Business Review",
      "News": "Nyheter",
      "Other": "Annet"
    },
    "yearFilter_zero": "År",
    "yearFilter": "År ({{count}})",
    "year": "År"
  },
  "employee": {
    "noResults": "Det er dessverre ingen ansatte som passer søkekriteriene du har oppgitt",
    "phone": "Telefon",
    "mail": "E-post",
    "location": "Kontor",
    "campusFilter_zero": "Campus",
    "campusFilter": "Campus ({{count}})",
    "campus": "Campus",
    "campuses": {
      "Oslo": "Oslo",
      "Bergen": "Bergen",
      "Stavanger": "Stavanger",
      "Trondheim": "Trondheim"
    }
  },
  "event": {
    "noResults": "Det er dessverre ingen arrangementer som passer søkekriteriene du har oppgitt",
    "when": "Når",
    "where": "Hvor",
    "campusFilter_zero": "Campus",
    "campusFilter": "Campus ({{count}})",
    "campus": "Campus",
    "campuses": {
      "Oslo": "Oslo",
      "Bergen": "Bergen",
      "Stavanger": "Stavanger",
      "Trondheim": "Trondheim"
    },
    "typeFilter_zero": "Arrangement",
    "typeFilter": "Arrangement ({{count}})",
    "type": "Arrangement",
    "types": {
      "alumni-partner": "Business og Alumni aktiviteter",
      "alumni-conference": "Alumni-konferanser",
      "research": "Forskning",
      "Executive": "Videreutdanning",
      "executive-webinar": "Videreutdanning webinar",
      "bi-startup": "BI Startup",
      "leaders-toolbox": "Lederens vektøykasse",
      "sustainability": "Bærekraft",
      "bachelor": "Bachelor",
      "master": "Master",
      "phd": "PhD"
    }
  },
  "programme": {
    "noResults": "Det er dessverre ingen studier eller kurs som passer søkekriteriene du har oppgitt",
    "credits": "{{count}} stp.",
    "loadFilter_zero": "Studieform",
    "loadFilter": "Studieform ({{count}})",
    "loads": {
      "FullTime": "Heltid",
      "PartTime": "Deltid"
    },
    "languageFilter_zero": "Undervisningsspråk",
    "languageFilter": "Undervisningsspråk ({{count}})",
    "language": "Undervisningsspråk",
    "languages": {
      "Norwegian": "Norsk",
      "English": "Engelsk"
    },
    "campusFilter_zero": "Sted",
    "campusFilter": "Sted ({{count}})",
    "campus": "Sted",
    "campuses": {
      "Oslo": "Oslo",
      "Bergen": "Bergen",
      "Stavanger": "Stavanger",
      "Trondheim": "Trondheim",
      "Online": "Nettstudier"
    },
    "levelFilter_zero": "Nivå",
    "levelFilter": "Nivå ({{count}})",
    "level": "Nivå",
    "levels": {
      "Bachelor": "Bachelor",
      "Master": "Master",
      "PhD": "PhD",
      "NonCreditCourses": "Kurs uten studiepoeng",
      "OneYearProgrammes": "Årsenhet",
      "AllCourses": "Alle kurs",
      "BachelorCourses": "Kurs bachelornivå",
      "MasterCourses": "Kurs masternivå"
    },
    "semesterFilter_zero": "Oppstart",
    "semesterFilter": "Oppstart ({{count}})",
    "semester": "Oppstart",
    "semesters": {
      "Fall_zero": "Høst",
      "Fall": "Høst {{year}}",
      "Spring_zero": "Vår",
      "Spring": "Vår {{year}}"
    },
    "academicFieldFilter_zero": "Fagområde",
    "academicFieldFilter": "Fagområde ({{count}})",
    "academicField": "Fagområde",
    "academicFields": {
      "RealEstateRetailAndBusinessLaw": "Eiendom, varehandel og forretningsjus",
      "FinanceEconomicsAndGovernance": "Finans, økonomi og styring",
      "Management": "Ledelse",
      "MarketingCommunicationAndCulture": "Markedsføring, kommunikasjon og kultur",
      "PublicSector": "Offentlig sektor",
      "ProjectManagement": "Prosjektledelse",
      "StrategyInnovationAndSustainability": "Strategi, innovasjon og bærekraft",
      "OrganisationalDevelopmentAndHumanResourceManagement": "Organisasjonsutvikling og Human Resource Management",
      "DigitalisationAndAnalytics": "Digitalisering og Analytics",
      "InternationalBusiness": "Internasjonal Business"
    }
  }
}
